import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkCard } from '~app/modules/storyblok/models';
import { environment } from '~env/environment';
import { GaTrackingEventAction, GaTrackingEventName, GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';

@Component({
  selector: 'app-popular-links-card',
  templateUrl: './popular-links-card.component.html',
  styleUrls: ['./popular-links-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularLinksCardComponent {
  @Input() card: LinkCard;

  readonly marketplaceLink = environment.appBaseUrl();

  sbFormatParam = '/m/';

  constructor(private gtmDatalayerService: GtmDatalayerService) {}

  goTo(path: string): void {
    window.location.href = `${this.marketplaceLink}${path}`;
  }

  clickPopularLinksEvent(path: string): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_POPULAR_LINKS_CLICKED,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.POPULAR_LINKS_CLICKED,
      label: path,
    });
  }
}
